function sAutoSelectText() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, elem, attrs, modelCtrl) {
      var oldValue = null;
      var key = {};

      elem.focus(function () {
        oldValue = elem.val();
        elem.select();
      });

      elem.on('keypress', function (e) {
        oldValue = elem.val();
        key.code = e.which;
        key.value = e.key;
      });

      elem.click(function () {
        oldValue = elem.val();
        elem.select();
      });

      elem.blur(function () {
        // hardcoded for now :(
        if ([43, 187].indexOf(key.code) >= 0) {
          modelCtrl.$setViewValue(oldValue);
          modelCtrl.$render();
        }
      });
    }
  };
}

export default sAutoSelectText;
